<template>
    <v-card class="mt-4" outlined>
        <v-card-title class="subtitle-1">
            CRUD Slots Configuration
        </v-card-title>
        <v-card-text>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Operation</th>
                            <th class="text-left">Mode</th>
                            <th class="text-left">Workflow</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="operation in operations" :key="operation">
                            <td class="font-weight-medium">{{ operation }}</td>
                            <td>
                                <v-select
                                    :value="getSlotMode(operation)"
                                    @input="(val) => setSlotMode(operation, val)"
                                    :items="modeOptions"
                                    dense
                                    hide-details
                                    style="max-width: 150px"
                                ></v-select>
                            </td>
                            <td>
                                <v-select
                                    v-if="getSlotMode(operation) === 'workflow'"
                                    :value="getSlotWorkflowId(operation)"
                                    @input="(val) => setSlotWorkflowId(operation, val)"
                                    :items="getWorkflowsForOperation(operation)"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    hide-details
                                    placeholder="Select workflow"
                                    style="max-width: 300px"
                                    :no-data-text="'No workflows with matching input type'"
                                ></v-select>
                                <span v-else class="grey--text">-</span>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "CrudSlotsEditor",
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        workflows: {
            type: Object,
            default: () => ({
                create_update: [],
                get: [],
                delete: [],
                filter: []
            })
        }
    },
    data() {
        return {
            operations: ['create_update', 'delete', 'get', 'filter'],
            modeOptions: [
                { text: 'Default', value: 'default' },
                { text: 'Workflow', value: 'workflow' },
                { text: 'Disabled', value: 'disabled' }
            ]
        }
    },
    methods: {
        getWorkflowsForOperation(operation) {
            const wfs = (this.workflows && this.workflows[operation]) || [];
            return wfs.map(wf => ({
                id: String(wf.id),
                name: wf.name || `Workflow ${wf.id}`
            }));
        },
        getSlotMode(operation) {
            const slot = this.value && this.value[operation];
            return (slot && slot.mode) || 'default';
        },
        getSlotWorkflowId(operation) {
            const slot = this.value && this.value[operation];
            return (slot && slot.workflow_id) || null;
        },
        setSlotMode(operation, mode) {
            const newValue = { ...this.value };
            if (mode === 'default') {
                delete newValue[operation];
            } else {
                newValue[operation] = {
                    slot_type: operation,
                    mode: mode,
                    workflow_id: this.getSlotWorkflowId(operation)
                };
            }
            this.$emit('input', newValue);
        },
        setSlotWorkflowId(operation, workflowId) {
            const newValue = { ...this.value };
            newValue[operation] = {
                slot_type: operation,
                mode: 'workflow',
                workflow_id: workflowId
            };
            this.$emit('input', newValue);
        }
    }
}
</script>

<style scoped>
.v-card-title {
    background-color: #f5f5f5;
}
</style>
